import React from 'react';
import { getPointOverviewLines } from './utils';
import { useLocalStorage } from './useLocalStorage';

const FinishOverlay = ({ finishReason, participants, activeRoutine, resetAll }) => {
  const taskCount = activeRoutine.tasks.length;

  const [streak] = useLocalStorage('morningMissionStreak', 0); 

  const sorted = [...participants].sort((a, b) => b.points - a.points);
  const topScore = sorted[0]?.points ?? 0;
  const winners = sorted.filter((c) => c.points === topScore);
  const winnerText =
    winners.length > 1
      ? `Uafgjort mellem ${winners.map((c) => c.name).join(', ')}!`
      : `${winners[0].name} vandt i dag!`;
  const finishText = [winnerText, participants.map((c) => `${c.name}: ${c.points} point`).join(' · '), `Streak: ${streak}`]
    .filter(Boolean)
    .join('\n');

  return (
    <div className="finish-overlay" id="finishOverlay" style={{ display: 'flex' }}>
      <div className="finish-card">
        <h2>{finishReason === 'timeout' ? '⏰ Tiden er gået. Det er tid til at gå!' : '🎉 Godt klaret! Missionen er gennemført.'}</h2>
        <p id="finishText" className="finish-text">
          {finishText}
        </p>
        <div className="summary-grid" id="summaryGrid">
          {participants.map((c) => (
            <div className="summary" key={`summary-${c.name}`}>
              <h3 className="summary-name">
                {c.avatar} {c.name}
              </h3>
              <div className="summary-lines">
                {getPointOverviewLines(c, taskCount).map((line) => (
                  <div className="line" key={`${c.name}-${line}`}>
                    {line}
                  </div>
                ))}
                <div className="line">{c.index >= taskCount ? 'Alt færdigt' : 'Mangler stadig noget'}</div>
              </div>
            </div>
          ))}
        </div>
        <button className="big-start" onClick={resetAll}>
          Start igen
        </button>
      </div>
    </div>
  );
};

export default FinishOverlay;
